export default "__VITE_ASSET__CFA3S5GK__"